import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../common/types';
import { assetShareMessages } from './assetShareMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the share page; each part uses its own slice of it */
import styles from './AssetShare.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The still picture full size, over the page (design asset-share c5, the zoom button). A click on
 * the picture, the close button or the Escape key closes it.
 */
const AssetShareZoomComponent: React.FC<{ src: string; alt: string; onClose: () => void }> = ({
  src,
  alt,
  onClose,
}) => {
  const intl = useIntl();

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className={styles.zoom} role="dialog" aria-modal="true" aria-label={alt} data-testid="asset-share-zoomed">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- Escape and the close button do the same */}
      <img className={styles.zoomPicture} src={src} alt={alt} onClick={onClose} />
      <button
        type="button"
        className={clsx(styles.glassButton, styles.zoomClose)}
        onClick={onClose}
        aria-label={intl.formatMessage(assetShareMessages.closeZoom)}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const AssetShareZoom = TypedMemo(AssetShareZoomComponent);
